
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ExperienceRateSectionProps {
  formData: {
    years_experience: number;
    hourly_rate: number;
  };
  onInputChange: (field: string, value: number) => void;
}

export default function ExperienceRateSection({ formData, onInputChange }: ExperienceRateSectionProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor="years_experience">Years of Experience</Label>
        <Input
          id="years_experience"
          type="number"
          value={formData.years_experience}
          onChange={(e) => onInputChange('years_experience', parseInt(e.target.value) || 0)}
        />
      </div>
      <div>
        <Label htmlFor="hourly_rate">Hourly Rate (€)</Label>
        <Input
          id="hourly_rate"
          type="number"
          value={formData.hourly_rate}
          onChange={(e) => onInputChange('hourly_rate', parseFloat(e.target.value) || 0)}
        />
      </div>
    </div>
  );
}
